import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeart} from '@fortawesome/free-solid-svg-icons';
import {AnimatePresence, motion} from 'framer-motion';
import {faHeart as faHeartOutline} from '@fortawesome/free-regular-svg-icons';
import {AnimatedNumber} from './AnimatedNumber';

export const AnimatedHearts = ({
    lives: livesProp,
    size: sizeProp = 30,
    maxLives: maxLivesProp = 3,
    gap = 2,
    disappearFrom = 'right',
    disabled = false,
    className,
}: {
    lives: number;
    maxLives?: number;
    size?: number;
    gap?: number;
    center?: boolean;
    disappearFrom?: 'left' | 'right';
    disabled?: boolean;
    className?: string;
}) => {
    const maxLives = Math.max(0, Math.min(maxLivesProp, 5));
    const lives = Math.max(0, Math.min(livesProp, maxLives));
    let size = sizeProp;
    if (maxLivesProp > 5) {
        size = sizeProp * 0.7;
    } else if (maxLives === 5) {
        size = sizeProp * 0.8;
    } else if (maxLives === 4) {
        size = sizeProp * 0.9;
    }

    return (
        <div
            className={`inline-flex items-center align-middle ${className ?? ''}`}
            style={{gap: gap * 2}}>
            {Array.from({length: maxLives}, (_, index) => (
                <span
                    className="relative inline-flex shrink-0 items-center justify-center"
                    style={{width: size, height: size}}
                    key={`heart-${index}`}>
                    <FontAwesomeIcon
                        icon={faHeartOutline}
                        fontSize={size}
                        className={disabled ? 'text-neutral-400' : 'text-red-600'}
                    />
                    <AnimatePresence initial={false}>
                        {(disappearFrom === 'left'
                            ? index >= maxLives - lives
                            : index < lives) && (
                            <motion.span
                                className="absolute inset-0 inline-flex items-center justify-center"
                                initial={{opacity: 0, scale: 0.5}}
                                animate={{opacity: 1, scale: 1}}
                                exit={{opacity: 0, scale: 0.5}}
                                transition={{duration: 0.3}}>
                                <FontAwesomeIcon
                                    icon={faHeart}
                                    className={
                                        disabled
                                            ? 'text-neutral-400'
                                            : 'text-red-600'
                                    }
                                    fontSize={size}
                                />
                            </motion.span>
                        )}
                    </AnimatePresence>
                </span>
            ))}
            {livesProp > 5 && (
                <span className="inline-flex items-center" style={{fontSize: size * 0.8}}>
                    +<AnimatedNumber value={livesProp} />
                </span>
            )}
        </div>
    );
};
